module.exports = __webpack_public_path__ + "static/media/projects_background.b7037289.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/projects_background.jpg
// module id = 290
// module chunks = 0